import { render } from "./tender_table.vue?vue&type=template&id=2c8fb054"
import script from "./tender_table.vue?vue&type=script&lang=js"
export * from "./tender_table.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/tenders/tenders/list/tender_table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c8fb054"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c8fb054', __exports__)) {
    console.log('reload')
    api.reload('2c8fb054', __exports__)
  }
  
  module.hot.accept("./tender_table.vue?vue&type=template&id=2c8fb054", () => {
    console.log('re-render')
    api.rerender('2c8fb054', render)
  })

}


export default __exports__